import { IConfig } from "./Render";
export const Polyline = ({points, stroke, stroke_width, fill }:IConfig)=>
{
    return (
       <polyline points = {points} stroke={stroke} strokeWidth={stroke_width} fill={fill} ></polyline>
    );
}